module.exports = __webpack_public_path__ + "img/GajTamilcopy.838c4d84.png";